module.exports = __webpack_public_path__ + "media/src/img/logo-uk_new_year-f678940a1b295027264ce292dd12cbd6.png";